import { RouteObject } from 'react-router-dom';
import MainLayoutProvider from '../providers/MainLayoutProvider';
import AuthGuard from '../utils/route-guard/AuthGuard';
import MainLayout from '../layouts/MainLayout';
import { lazy, Suspense } from 'react';
import PhoenixLoader from '../components/common/PhoenixLoader';

const Location = lazy(() => import('pages/mdm/LocationPage'));

const MdmRoutes: RouteObject = {
  path: '/mdm/',
  element: (
    <MainLayoutProvider>
      <AuthGuard>
        <MainLayout />
      </AuthGuard>
    </MainLayoutProvider>
  ),
  children: [
    {
      path: 'location',
      index: true,
      element: (
        <Suspense fallback={<PhoenixLoader />}>
          <Location />
        </Suspense>
      )
    }
  ]
};

export default MdmRoutes;
